/**
 * Sanitizes a search query by:
 * 1. Removing special characters that could be used for XSS or regex attacks
 * 2. Limiting the length of the search query
 * 3. Trimming whitespace
 */
export const sanitizeSearchQuery = (query: string): string => {
  // Remove special characters and potential HTML/script tags
  const sanitized = query
    .replace(/<[^>]*>/g, '') // Remove HTML tags
    .replace(/[\\^$.*+?()[\]{}|]/g, '') // Remove regex special characters
    .replace(/[^\w\s-]/g, '') // Only allow word characters, spaces, and hyphens
    .trim();

  // Limit the length of the search query
  const MAX_QUERY_LENGTH = 100;
  return sanitized.slice(0, MAX_QUERY_LENGTH);
}; 